import React, { useState } from "react";

import clsx from "clsx";

import versionTextFile from "../../../VERSION.txt";
import navStyles from "../styles";

const DisplayVersion = () => {
  const classes = navStyles();
  const [text, setText] = useState("");

  fetch(versionTextFile)
    .then((response) => response.text())
    .then((textContent) => {
      setText(textContent);
    });

  return (
    <span
      style={{
        color: "inherit",
        fontVariant: "body2",
      }}
      className={clsx(classes.versionDisplay)}
    >
      {text}
    </span>
  );
};

export default DisplayVersion;
